import {Component, OnDestroy, OnInit} from '@angular/core';
import {BlogService} from '../blog.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';

@Component({
    selector: 'app-blog-category',
    templateUrl: './blog-category.component.html',
    styleUrls: ['./blog-category.component.scss']
})
export class BlogCategoryComponent implements OnInit, OnDestroy {

    category;
    categories = [];
    articles = [];
    navigationSubscription;

    constructor(
        private blogService: BlogService,
        private route: ActivatedRoute,
        private router: Router,
    ) {
        this.navigationSubscription = this.router.events.subscribe((e: any) => {
            // If it is a NavigationEnd event re-initialise the component
            if (e instanceof NavigationEnd) {
                this.getCategory();
            }
        });
    }

    ngOnInit(): void {
        this.getCategories();
    }

    ngOnDestroy() {
        if (this.navigationSubscription) {
            this.navigationSubscription.unsubscribe();
        }
    }

    getCategory() {
        this.blogService.getCategory(this.route.snapshot.params.categorySlug).subscribe(data => {
            this.category = data;
            this.articles = data.articles;
        });
    }

    getCategories() {
        this.blogService.getCategories().subscribe(data => {
            this.categories = data;
        });
    }

}
